module.exports = __webpack_public_path__ + "img/back invisible zipper length.8c7a1083.png";